// this landscape is apeared and rendered in the home page.
const Landscape = () => {
  return (
    <section className="px-4 lg:px-16">
      <div className="my-10 lg:container">
        <div
          className="flex min-h-[20rem] w-full flex-col rounded-3xl sm:min-h-[30rem] lg:min-h-[50rem]"
          style={{
            background:
              "linear-gradient(rgba(0,0,0,0.1),rgba(0,0,0,0.1)),url('/images/our-team25.jpg')",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        />
      </div>
    </section>
  );
};
export default Landscape;
